export const saveBinaryBufferToFile = (
  file: Uint8Array,
  name: string,
  type: string,
) => {
  const blob = new Blob([file], {
    type,
  });

  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();

  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
